<template>
  <section class="requisition-form" v-loading="loading"></section>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters("cases", ["getReport"]),
    ...mapGetters("errors", ["getError"]),
  },
  async mounted() {
    this.is_color_variant = this.$route.query.isColorPrint;
    await this.fetchReport();
  },
  data() {
    return {
      reportUrl: "",
      loading: false,
      is_color_variant: true,
    };
  },
  methods: {
    async fetchReport() {
      try {
        this.loading = true;
        this.$store.commit("errors/clear", null, { root: true });
        let params = {
          caseId: this.$route.params.case_id,
          is_color_variant: this.is_color_variant,
        };
        await this.$store.dispatch("cases/fetchRequisitionById", params);
        if (this.getReport) {
          document.write(this.getReport);
          setTimeout(() => {
            window.print();
          }, 2500);
        }
        this.loading = false;
      } catch (err) {
        this.loading = false;
      }
    },
    onPrint() {
      window.print();
    },
  },
};
</script>
